module.exports = __webpack_public_path__ + "static/media/progger2.83d8bc87.png";